module.exports = __webpack_public_path__ + "static/mstile-310x310-2ecd5dafd882a0bb539ac15152abc648.png";